export default {
  navigation: {
    next: "次へ",
    back: "戻る",
    surveyNavigation: "アンケートナビゲーション",
    workspace: {
      home: "ホーム",
      example: "例"
    }
  }
}
